import { Component, OnInit, inject } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Page} from '../../../core/pagination/page';
import {PageRequest} from '../../../core/pagination/page-request';
import {SortOrder} from '../../../core/sort/sort-order';
import {Router} from '@angular/router';
import {Admin} from '../../../admin/admin';
import {AdminService} from '../../../admin/admin.service';
import {DialogService} from '../../../core/dialog/dialog.service';
import {filter, mergeMap, tap} from 'rxjs/operators';

@Component({
    templateUrl: './admins.page.html',
    styleUrls: ['./admins.page.scss'],
    standalone: false
})
export class AdminsPage implements OnInit {
  private adminService = inject(AdminService);
  private dialogService = inject(DialogService);
  private router = inject(Router);

  initialPageRequest: PageRequest<Admin> = PageRequest.firstPageRequest<Admin>(SortOrder.ASCENDING, 5);
  adminsPage$: Subject<Page<Admin>> = new Subject<Page<Admin>>();
  private currentPageRequest: PageRequest<Admin>;

  ngOnInit(): void {
    this.getAdmins$(this.initialPageRequest).subscribe();
  }

  navigateToAdmin(admin: Admin): void {
    this.router.navigateByUrl(`/admins/${admin.getId()}`);
  }

  deleteAdmin(admin: Admin): void {
    this.dialogService
      .askConfirmation({message: `Ben je zeker dat je ${admin.getVoornaam()} wil verwijderen?`})
      .pipe(
        filter(confirmation => confirmation),
        mergeMap(() => this.adminService.deleteAdmin$(admin.getId())),
        mergeMap(() => this.getAdmins$(this.currentPageRequest.toFirstPage()))
      )
      .subscribe();
  }

  navigateToAddAdmin(): void {
    this.router.navigateByUrl('/admins/toevoegen');
  }

  onPageChange(pageRequest: PageRequest<Admin>): void {
    this.getAdmins$(pageRequest).subscribe();
  }

  private getAdmins$(pageRequest: PageRequest<Admin>): Observable<Page<Admin>> {
    this.currentPageRequest = pageRequest;
    return this.adminService
      .getAdmins$(pageRequest)
      .pipe(tap(page => this.adminsPage$.next(page)));
  }
}
